import { Helmet } from "react-helmet-async";

const SITE_NAME = "Elite Solutions Hub";
const DEFAULT_DESCRIPTION =
  "Elite Solutions Hub is a London-based software consultancy. We architect, build, and operate mission-critical platforms for FinTech, Healthcare, E-commerce, Logistics, Education, SaaS and Government.";
const DEFAULT_OG_IMAGE = "/og-default.svg";

/**
 * Per-page SEO + Open Graph meta. Use on every page.
 * Falls back to sensible defaults pulled from the brand guide.
 */
export default function SeoHead({
  title,
  description,
  path,
  image,
  type = "website",
  noindex = false,
}) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Engineered Conviction. Delivered Software.`;
  const desc = description || DEFAULT_DESCRIPTION;
  const baseUrl = (typeof window !== "undefined" ? window.location.origin : "https://elitesolutionshub.com").replace(/\/$/, "");
  const url = `${baseUrl}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
  const ogImage = `${baseUrl}${image || DEFAULT_OG_IMAGE}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
